export default __webpack_public_path__ + "static/media/project-default.41802df5.jpg";